import { StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

export const ACTIVE_TILE_AVATAR_SIZE = 34;
const LIVE_DOT_SIZE = 6;
/** The row's gradient runs left to right into the same deep purple the slate card ends in. */
export const ACTIVE_ROW_GRADIENT_END = '#2A1F3D';

export const getActiveChallengeTileStyles = (theme: Theme) =>
  StyleSheet.create({
    rowOuter: {
      borderRadius: 14,
      overflow: 'hidden',
      shadowColor: theme.shadow,
      shadowOpacity: 0.4,
      shadowRadius: 4,
      shadowOffset: { width: 0, height: 2 },
      elevation: 2,
    },
    row: {
      minHeight: 56,
      paddingVertical: 8,
      paddingHorizontal: 14,
      flexDirection: 'row',
      alignItems: 'center',
      gap: 10,
    },
    rowPressed: {
      opacity: 0.8,
    },
    rowHover: {
      opacity: 0.92,
    },
    side: {
      flex: 1,
      minWidth: 0,
      flexDirection: 'row',
      alignItems: 'center',
      gap: 8,
    },
    sideRight: {
      justifyContent: 'flex-end',
    },
    sideText: {
      minWidth: 0,
    },
    sideTextRight: {
      alignItems: 'flex-end',
    },
    avatarSelf: {
      borderWidth: 2,
      borderColor: theme.success,
      backgroundColor: theme.background.inset,
    },
    avatarOpponent: {
      borderWidth: 2,
      borderColor: theme.gray[200],
      backgroundColor: theme.background.inset,
    },
    name: {
      fontSize: 12,
      fontWeight: '700',
      color: theme.white,
    },
    statusRow: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 4,
    },
    statusText: {
      fontSize: 10,
    },
    statusLeading: {
      color: theme.success,
    },
    statusBehind: {
      color: theme.error,
    },
    statusLevel: {
      color: theme.gray[500],
    },
    liveDot: {
      width: LIVE_DOT_SIZE,
      height: LIVE_DOT_SIZE,
      borderRadius: theme.borderRadius.full,
    },
    liveDotLeading: {
      backgroundColor: theme.success,
    },
    liveDotBehind: {
      backgroundColor: theme.error,
    },
    liveDotLevel: {
      backgroundColor: theme.gray[500],
    },
    format: {
      fontSize: 10,
      color: theme.gray[500],
    },
    center: {
      alignItems: 'center',
      gap: 1,
    },
    score: {
      flexDirection: 'row',
      alignItems: 'baseline',
      gap: 4,
    },
    scoreMine: {
      fontSize: 22,
      fontWeight: '800',
      lineHeight: 24,
      color: theme.success,
      fontVariant: ['tabular-nums'],
    },
    scoreSep: {
      fontSize: 13,
      color: theme.gray[400],
    },
    scoreTheirs: {
      fontSize: 22,
      fontWeight: '800',
      lineHeight: 24,
      color: theme.white,
      fontVariant: ['tabular-nums'],
    },
    kickoff: {
      fontSize: 16,
      fontWeight: '800',
      lineHeight: 20,
      color: theme.accent,
      fontVariant: ['tabular-nums'],
    },
    gamesLeft: {
      fontSize: 9,
      fontWeight: '700',
      color: theme.gray[500],
      letterSpacing: 0.6,
      textTransform: 'uppercase',
    },
  });

export type ActiveChallengeTileStyles = ReturnType<typeof getActiveChallengeTileStyles>;
